import { CountUp } from 'countup.js';
function menuBtn() {
    $('.hamburger').click(function(e) {
        e.preventDefault()
        $(this).toggleClass('is-active');
        $('.menu-overlay').toggleClass('active');
    });
}
const wow = new WOW(
    {
      boxClass:     'wow',      // animated element css class (default is wow)
      animateClass: 'animated', // animation css class (default is animated)
      offset:       0,          // distance to the element when triggering the animation (default is 0)
      mobile:       true,       // trigger animations on mobile devices (default is true)
      live:         true,       // act on asynchronously loaded content (default is true)
      callback:     function(box) {
        // the callback is fired every time an animation is started
        // the argument that is passed in is the DOM node being animated
      },
      scrollContainer: null // optional scroll container selector, otherwise use window
    }
);


function scrollFunction() {
    if (document.body.scrollTop > 100 || document.documentElement.scrollTop > 100) {
        $('header').addClass('active');
        $('body').addClass('active');
    } else {
        $('header').removeClass('active');
        $('body').removeClass('active');
    }
} 

function handlePreloader()
{
    window.onload = function () {
        // console.log('works');

        $('.preloader').fadeOut(500, function(){
            $('.preloader').remove();
        });
    }

    setTimeout(function () {
        $('.preloader').fadeOut(500, function(){
            $('.preloader').remove();
        });
    }, 4000);
}

function counterItems(){
    $('[data-count]').each(function(index, element) {
        var endValue = element.getAttribute('count-item');
        var queueCountAnimation = new CountUp(element, endValue);
        queueCountAnimation.start();
    });
};

$( document ).ready(function() {

    $("#query-btn").click(function(){
        var term = $("#s-query").val();
        var page = $("#s-query").data('page');
        if(term != ""){
            window.location = baseURL + '/'+page+'?q=' + term;
        }

    });

    $("#s-query").keypress(function(e){
        if(e.which == 13) {
            var term = $(this).val();
            var page = $(this).data('page');
            if(term != ""){
                window.location = baseURL + '/'+page+'?q=' + term;
            }
        }
    });

    $(document).on('click', '#modeul-app-search', function(e) {
        e.preventDefault();

        var url = '';
        if ($('#scity option:selected').val() != '') {
            url += '?c=' + $('#scity option:selected').val();
        }

        if ($('#sap_type option:selected').val() != '') {
            if (url == '') {
                url += '?t=' + $('#sap_type option:selected').val();
            } else {
                url += '&t=' + $('#sap_type option:selected').val();
            }
        }


        window.location = baseURL + '/' + $(this).data('page') + url;
    });
    
    // $("ul.dropdown-menu [data-toggle='dropdown']").on("click", function(event) {
    //     event.preventDefault();
    //     event.stopPropagation();

    //     $(this).siblings().toggleClass("show");


    //     if (!$(this).next().hasClass('show')) {
    //         $(this).parents('.dropdown-menu').first().find('.show').removeClass("show");
    //     }
    //     $(this).parents('li.nav-item.dropdown.show').on('hidden.bs.dropdown', function(e) {
    //         $('.dropdown-submenu .show').removeClass("show");
    //     });

    // });
    // var images = document.querySelectorAll('.section-bg.parallaxed');
    // new simpleParallax(images, {
    //     orientation: 'up',
    //     delay: 0,
    //     transition: 'cubic-bezier(0.215, 0.610, 0.355, 1)',
    // });

     // Add smooth scrolling to all links
     $(".scroll-to").on('click', function(event) {
        // Make sure this.hash has a value before overriding default behavior
        if (this.hash !== "") {
            // Prevent default anchor click behavior
            event.preventDefault();

            // Store hash
            var hash = this.hash;

            // Using jQuery's animate() method to add smooth page scroll
            // The optional number (800) specifies the number of milliseconds it takes to scroll to the specified area
            $('html, body').animate({
                scrollTop: $(hash).offset().top
            }, 800, function(){

                // Add hash (#) to URL when done scrolling (default click behavior)
                window.location.hash = hash;
            });
        } // End if
    });
    var swiperPlans = new Swiper('.swiper-plans', {
        // Optional parameters
        // loop: true,
        spaceBetween: 20,
        slidesPerView: 1,
        centeredSlidesBounds: true,
        centeredSlides: true,
        watchOverflow: true,
        // Navigation arrows
        navigation: {
          nextEl: '.swiper-plan-next',
          prevEl: '.swiper-plan-prev',
        },
        // Responsive breakpoints
        breakpoints: {
          // when window width is >= 992px
          992: {
            slidesPerView: 3,
            spaceBetween: 20,
          },
        }
    })

    if ( $(window).width() < 768 ) {
        var swiperTimeline = new Swiper('.swiper-timeline', {
            // Optional parameters
            spaceBetween: 10,
            slidesPerView: 6,
            freeMode: true,
            // centeredSlidesBounds: true,
            centeredSlides: true,
            watchSlidesVisibility: true,
            watchSlidesProgress: true,
            allowSlideNext: true,
            allowSlidePrev: true,
          
            // Navigation arrows
            navigation: {
              nextEl: '.swiper-timeline-next',
              prevEl: '.swiper-timeline-prev',
            },
            on: {
              slideChange: function () {
                    let index_currentSlide = swiperTimeline.realIndex,
                    currentSlide = swiperTimeline.slides[index_currentSlide]
                    currentSlide.click();
                    //   let galleryBg = document.getElementById('gallery-bg');
                    //   galleryBg.classList.add('inactive');
                    //   galleryBg.style.backgroundImage = currentSlide.style.backgroundImage;
                    //   galleryBg.classList.remove('inactive');
              },
              click: function (swiper, event) {
                /* do something */
                if ( swiperTimeline.clickedIndex != undefined ) {
                    swiperTimeline.slideTo(swiperTimeline.clickedIndex, 1000, false);
                }
              },
            },
        })
    }

    
    var swiperProjectsFeatured = new Swiper('.swiper-projects--featured', {
      // Optional parameters
      loop: true,
      spaceBetween: 10,
      slidesPerView: 1,
      speed: 1000,
    
      // Navigation arrows
      navigation: {
        nextEl: '.swiper-project-next',
        prevEl: '.swiper-project-prev',
      },
  })

    var galleryThumbs = new Swiper('.gallery-thumbs', {
      spaceBetween: 10,
      slidesPerView: 4,
      centeredSlides: true,
      loop: true,
      effect: 'slide',
      speed: 1000,
      watchSlidesVisibility: true,
      watchSlidesProgress: true,
      // Responsive breakpoints
      breakpoints: {
        // when window width is >= 320px
        768: {
          slidesPerView: 4,
          spaceBetween: 10
        },
        // when window width is >= 480px
        992: {
          slidesPerView: 5,
          spaceBetween: 10,
        },
      }
    });
    var galleryTop = new Swiper('.gallery-top', {
      spaceBetween: 10,
      effect: 'fade',
      speed: 1000,
      // loop: true,
      // loopedSlides: 5, //looped slides should be the same
      navigation: {
        nextEl: '.swiper-gallery-next',
        prevEl: '.swiper-gallery-prev',
      },
      thumbs: {
        swiper: galleryThumbs,
      },
      on: {
        slideChange: function () {
            let index_currentSlide = galleryTop.realIndex,
            currentSlide = galleryTop.slides[index_currentSlide];
            let galleryBg = document.getElementById('gallery-bg');
            galleryBg.classList.add('inactive');
            galleryBg.style.backgroundImage = currentSlide.style.backgroundImage;
            galleryBg.classList.remove('inactive');
        },
      },
    });

    var searchToggle = document.getElementById('search-toggle');
    var searchBox = document.getElementById('navbar-search');
    $(searchToggle).click(function(e){
      e.preventDefault();
      $(searchBox).toggleClass("active");
    });

    menuBtn();
    handlePreloader();
    wow.init();

    if ($(".template-boxes--counter").length > 0) {
        var waypoint = new Waypoint({
            element: document.getElementsByClassName('template-boxes--counter'),
            handler: function(direction) {
                counterItems();
            },
            offset: "25%"
        });
    }

    

    if ($(".section.template-timeline").length > 0) {
        var waypoint = new Waypoint({
            element: document.getElementsByClassName('template-timeline'),
            handler: function(direction) {
                $('.timeline-slider').toggleClass('active');
            },
            offset: "0%"
        });
    }

    var discreteElements = document.getElementsByClassName('milestone-box')
        for (var i = 0; i < discreteElements.length; i++) {
        new Waypoint({
            element: discreteElements[i],
            handler: function(direction) {
                // var previousWaypoint = this.previous()
                var nextWaypoint = this.next()
                $(discreteElements).removeClass('active');
                this.element.classList.add('active');
                if (nextWaypoint) {
                    $(nextWaypoint.element).addClass('active');
                    // if ( $(window).width() < 768 )
                    // {
                    //     let swiperId = this.element.getAttribute('id')
                    //     swiperTimeline.slideTo(swiperId, 0, false);
                    // }
                }
            },
            offset: "0%",
            continuous: false
        })
    }
    if ( $(window).width() < 1199.98 )
    {
        $('.navbar-nav .navbar-dropdown.shown').show();
        $('.navbar-nav .navbar-dropdown.shown').parent('li').addClass('active');
        $( ".open-submenu" ).click(function() {
            $(this).parent('li').toggleClass('active').siblings('li').removeClass('active');
            $(this).siblings('.navbar-dropdown').slideToggle();
        });
    }

    
    if ( $(".gallery-top .swiper-slide").length > 0 ) {
        var lightboxGallery = $('.gallery-top .swiper-slide').simpleLightbox({
            navText: ['<i class="fas fa-chevron-left"></i>','<i class="fas fa-chevron-right"></i>']
        });
    }

    if ( $(".card.template-plan").length > 0 ) {
        var lightboxPlans = $('.card.template-plan').simpleLightbox({
            navText: ['<i class="fas fa-chevron-left"></i>','<i class="fas fa-chevron-right"></i>']
        });
    }

    if ( $('.btn-cta').length > 0 ) {
        $(window).scroll(function() {
            if ($('body').height() <= ($(window).height() + $(window).scrollTop())) {
                $('.btn-cta').removeClass('active');
            } else
            {
                $('.btn-cta').addClass('active');
            }
        });
    }

    if ( $('#section-contact').length > 0 ) {
        $('.chat-container').attr("href", "#section-contact");
    }

    
    // When the user scrolls down 80px from the top of the document, resize the navbar's padding and the logo's font size
    window.onscroll = function() {scrollFunction()};
});



// WEBPACK FOOTER //
// ./resources/assets/js/javascript.js